/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { IntegrationConfigResponseDto } from '../model';
/**
 * IntegrationConfigApi - axios parameter creator
 * @export
 */
export const IntegrationConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get OAuth configuration for integration provider
         * @param {IntegrationConfigControllerGetIntegrationConfigProviderEnum} provider Integration provider name (garmin or strava)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationConfigControllerGetIntegrationConfig: async (provider: IntegrationConfigControllerGetIntegrationConfigProviderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('integrationConfigControllerGetIntegrationConfig', 'provider', provider)
            const localVarPath = `/api/integration-config/{provider}`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationConfigApi - functional programming interface
 * @export
 */
export const IntegrationConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get OAuth configuration for integration provider
         * @param {IntegrationConfigControllerGetIntegrationConfigProviderEnum} provider Integration provider name (garmin or strava)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationConfigControllerGetIntegrationConfig(provider: IntegrationConfigControllerGetIntegrationConfigProviderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationConfigControllerGetIntegrationConfig(provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationConfigApi.integrationConfigControllerGetIntegrationConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntegrationConfigApi - factory interface
 * @export
 */
export const IntegrationConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationConfigApiFp(configuration)
    return {
        /**
         * 
         * @summary Get OAuth configuration for integration provider
         * @param {IntegrationConfigControllerGetIntegrationConfigProviderEnum} provider Integration provider name (garmin or strava)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationConfigControllerGetIntegrationConfig(provider: IntegrationConfigControllerGetIntegrationConfigProviderEnum, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationConfigResponseDto> {
            return localVarFp.integrationConfigControllerGetIntegrationConfig(provider, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationConfigApi - object-oriented interface
 * @export
 * @class IntegrationConfigApi
 * @extends {BaseAPI}
 */
export class IntegrationConfigApi extends BaseAPI {
    /**
     * 
     * @summary Get OAuth configuration for integration provider
     * @param {IntegrationConfigControllerGetIntegrationConfigProviderEnum} provider Integration provider name (garmin or strava)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationConfigApi
     */
    public integrationConfigControllerGetIntegrationConfig(provider: IntegrationConfigControllerGetIntegrationConfigProviderEnum, options?: RawAxiosRequestConfig) {
        return IntegrationConfigApiFp(this.configuration).integrationConfigControllerGetIntegrationConfig(provider, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const IntegrationConfigControllerGetIntegrationConfigProviderEnum = {
    Garmin: 'garmin',
    Strava: 'strava'
} as const;
export type IntegrationConfigControllerGetIntegrationConfigProviderEnum = typeof IntegrationConfigControllerGetIntegrationConfigProviderEnum[keyof typeof IntegrationConfigControllerGetIntegrationConfigProviderEnum];
